import Cookies from "js-cookie";

let redirecting = false;

export const clearSessionCookies = () => {
  Cookies.remove("JWTToken");
  Cookies.remove("userID");
  Cookies.remove("userRole");
  Cookies.remove("tokenExpiry");
};

const AUTH_MESSAGE_PATTERNS = [
  /invalid token/i,
  /token expired/i,
  /unauthorized/i,
  /session expired/i,
  /session is no longer valid/i,
];

export const isAuthFailurePayload = (data, httpStatus) => {
  if (httpStatus === 401 || httpStatus === 403) {
    return true;
  }
  const status = data?.status?.toLowerCase?.();
  const message = data?.message ?? "";
  if (status !== "fail" || !message) {
    return false;
  }
  return AUTH_MESSAGE_PATTERNS.some((pattern) => pattern.test(message));
};

const shouldSkipAuthRedirect = (url = "") =>
  url.includes("/api/Auth/Login") || 
  url.includes("/api/Auth/logout") ||
  url.includes("/api/Auth/VerifyHROtp") ||
  url.includes("/api/Auth/SendHROtp");

/** 
 * Clear session, toast once, and hard-navigate to appropriate login.
 * Dynamically resolves target route based on user role / current URL.
 */
export const handleAuthFailure = (message, requestUrl = "", customRedirect = null) => {
  if (shouldSkipAuthRedirect(requestUrl) || redirecting) {
    return;
  }

  const userRole = Cookies.get("userRole")?.toLowerCase();
  const currentPath = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
  let redirectPath = "/";
  if (customRedirect) {
    redirectPath = customRedirect;
  } else if (
    userRole === "company" ||
    userRole === "hr" ||
    currentPath.startsWith("/company") ||
    requestUrl.toLowerCase().includes("hrotp") ||
    requestUrl.toLowerCase().includes("company")
  ) {
    redirectPath = "/CompanyLogin";
  }

  redirecting = true;
  clearSessionCookies();
  const text = message || "Your session is no longer valid. Please log in again.";
  if (typeof window !== "undefined" && typeof window.CustomToast === "function") {
    window.CustomToast("fail", text);
  }

  if (typeof window !== "undefined") {
    window.location.replace(redirectPath);
  }
};

export const isAuthRedirectInProgress = () => redirecting;